import { render, staticRenderFns } from "./SubsectionTitle.vue?vue&type=template&id=69d4e0e4"
import script from "./SubsectionTitle.vue?vue&type=script&lang=js"
export * from "./SubsectionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports